<i class="fa {{icon}}" [ngClass]="{
    'red': isPcColor === true,
    'icon-size-big': size === 'lg',
    'icon-size-bigger': size === 'xl',
    'icon-size-bigger-plus': size === '2xl',
    'icon-size-biggest': size === '3xl',
    'icon-size-small': size === 'sm',
    'icon-size-smaller': size === 'xs'
}"></i>